// Clean HTML content while preserving structure
export const cleanHtmlContent = (htmlContent) => {
    if (!htmlContent) return '';
    
    // You can add any specific cleaning logic here if needed
    // For now, return the HTML as-is since dangerouslySetInnerHTML will handle it
    return htmlContent;
};

// Format date
export const formatBlogDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

// Calculate read time based on content length
export const calculateReadTime = (content) => {
    if (!content) return '1 min read';
    
    // Strip HTML tags to get plain text
    const plainText = content.replace(/<[^>]*>/g, '');
    const wordsPerMinute = 200;
    const wordCount = plainText.split(/\s+/).length;
    const readTime = Math.ceil(wordCount / wordsPerMinute);
    
    return `${readTime} min read`;
};

// Get author initials for avatar
export const getAuthorInitials = (name) => {
    if (!name) return 'AU';
    
    return name
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase()
        .substring(0, 2);
};

// Get gradient color based on tag or index
export const getBlogGradient = (tag, index = 0) => {
    const gradients = [
        'from-[#06D6A0]/20 to-[#0096C7]/20',
        'from-[#FFD166]/20 to-[#06D6A0]/20',
        'from-[#4361EE]/20 to-[#0096C7]/20',
        'from-[#0096C7]/20 to-[#4361EE]/20',
        'from-[#06D6A0]/20 to-[#FFD166]/20',
        'from-[#FFD166]/20 to-[#06D6A0]/20'
    ];
    
    // Use index to cycle through gradients
    return gradients[index % gradients.length];
};

// Get icon based on tag
export const getBlogIcon = (tag) => {
    const iconMap = {
        'Resume Tips': 'fa-file-alt',
        'Career Advice': 'fa-briefcase',
        'Industry Trends': 'fa-chart-line',
        'Job Search': 'fa-search',
        'Interview Tips': 'fa-comments',
        'Networking': 'fa-network-wired'
    };
    
    return iconMap[tag] || 'fa-newspaper';
};

// Get color based on tag
export const getBlogTagColor = (tag) => {
    const colorMap = {
        'Resume Tips': '#06D6A0',
        'Career Advice': '#FFD166',
        'Industry Trends': '#4361EE',
        'Job Search': '#0096C7',
        'Interview Tips': '#06D6A0',
        'Networking': '#FFD166'
    };
    
    return colorMap[tag] || '#0096C7';
};